import type { ObjectScope } from "./cryptoV2";
export const dataKeyScope = (scope: Pick<ObjectScope, "datasetId" | "generation" | "keyVersion">): ObjectScope => ({
  datasetId: scope.datasetId,
  generation: scope.generation,
  keyVersion: scope.keyVersion,
  objectId: "device-data-key",
  format: 2,
});
